module.exports = __webpack_public_path__ + "img/hvs-footer.24df1a17.png";